export default Object.freeze([
  'Первичное',
  'Повторное',
])
